import styled from '@emotion/styled'
import CryptoJS from 'crypto-js'
import { motion } from 'framer-motion'
import QRCode from 'qrcode'
import { useCallback, useEffect, useRef, useState } from 'react'
import { toast } from 'react-hot-toast'
import { useRecoilState, useRecoilValue } from 'recoil'

import just_j from '@/assets/images/just/just_j.png'
import just_l from '@/assets/images/just/just_l.png'
import just_choose from '@/assets/images/just/just-choose.png'
import just_choose_no from '@/assets/images/just/just-choose-no.png'
import just_sao from '@/assets/images/just/just-sao.png'
import just_small_ewm from '@/assets/images/just/just-small-ewm.png'
import just_success from '@/assets/images/just/just-success.png'
import Modal from '@/components/Modal'
import { JustUser, justUserState, paramsState, restState, roomLineState } from '@/store/room'
import { browserType } from '@/utils/tool'

import { roomEvent, rtmClient } from '../..'

export default function Index() {
  const [justShow, setJustShow] = useState(false)
  const [rest, setRest] = useRecoilState(restState)
  const [justUser, setJustUser] = useRecoilState(justUserState)
  const params = useRecoilValue(paramsState)
  const serveUnixTimeRef = useRef(0)
  // 区分弹框内容
  const [justType, setjustType] = useState<'one' | 'two'>('one')
  // 选择的流类型
  const [justChoose, setjustChoose] = useState<'just' | 'local' | ''>('')
  // 二维码
  const [QRImgUrl, setQRImgUrl] = useState<string>('')

  useEffect(() => {
    // 课程时间（二维码用）
    roomEvent.on('roomTime', roomTime)
    // 远端just信令
    rtmClient.on('ArtExtensionVideo', ArtExtensionVideo)
    // 流监听
    roomEvent.on('localJustChange', localJustChange)
    return () => {
      roomEvent.removeListener('roomTime', roomTime)
      rtmClient.removeListener('ArtExtensionVideo', ArtExtensionVideo)
      roomEvent.removeListener('localJustChange', localJustChange)
    }
  }, [])
  const roomLine = useRecoilValue(roomLineState)

  const roomTime = useCallback((seconds: number, serveUnixTime: number) => {
    serveUnixTimeRef.current = serveUnixTime
  }, [])

  // 获取设备名称
  const getSysName = () => {
    const brower = browserType()
    const name = brower.system || ''
    return name ? `pc_${name}` : 'pc'
  }

  // 二维码
  const getQrCode = () => {
    const timeStamp = serveUnixTimeRef.current * 1000
    const QRlink = `artjust://joinRoom?justUid=${params.justStudentId}&userId=${params.mainStudentId}&roomId=${params.roomId}&rtcToken=&appType=0&phoneName=${getSysName()}&createTime=${timeStamp}`
    console.log('Just QRcode', QRlink)

    const key64 = CryptoJS.enc.Base64.parse(import.meta.env.VITE_APP_Just_key)
    const ivs64 = CryptoJS.enc.Base64.parse(import.meta.env.VITE_APP_Just_iv)
    const keyStr = CryptoJS.enc.Hex.stringify(key64)
    const ivsStr = CryptoJS.enc.Hex.stringify(ivs64)
    const key = CryptoJS.enc.Hex.parse(keyStr)
    const ivs = CryptoJS.enc.Hex.parse(ivsStr)
    const srcs = CryptoJS.enc.Utf8.parse(QRlink)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: ivs,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    const encodeLink = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)

    QRCode.toDataURL(encodeLink, { errorCorrectionLevel: 'L', margin: 2, width: 228 }, (err, url) => {
      if (err) throw err
      setQRImgUrl(url)
    })
  }

  // 老师just状态影响选中显示
  const localJustChange = useCallback((isPlay: boolean) => {
    if (isPlay) {
      // 收到流了，翻转到选择流，这时候选择为空
      setjustType('two')
      setjustChoose('')
    } else {
      // 流断开了一定选择local
      setjustType('one')
      chooseStream('local')
    }
  }, [])

  // 监听是否需要生成二维码
  useEffect(() => {
    if (justShow && justType === 'one') {
      if (roomLine === 'agora') {
        // 二维码
        getQrCode()
      } else {
        toast('当前线路不支持扩展屏幕')
      }
    }
  }, [justShow])

  // just接受选择信令
  const ArtExtensionVideo = useCallback(
    (memberId: string, payload: any) => {
      const { userInfo = [] } = payload
      const tea = userInfo.find((v: { userId: string }) => v.userId.slice(0, 2) === '10')
      if (tea) {
        setJustUser((v) => ({ ...v, [tea.userId]: tea.isSelected }))
      }
    },
    [params]
  )

  // 选择视频
  const chooseStream = (type: 'just' | 'local' | '') => {
    setjustChoose(type)
    const isJust = type === 'just'
    const jUser = { ...justUser, [params.mainStudentId]: isJust }
    // 老师选择
    setJustUser(jUser)
    setJustShow(false)

    // 发送信令
    const payload: JustUser[] = []
    Object.keys(jUser).forEach((v) => {
      payload.push({
        userId: v, // 10xxx,20xxx
        isSelected: jUser[v]
      })
    })
    rtmClient.sendMessage('ArtExtensionVideo', { userInfo: payload })
  }

  return (
    <>
      <div onClick={() => setJustShow(true)} className="anim_btn2 w-[5vh] h-[5vh] just"></div>
      <Modal show={justShow && rest.state !== 1} footer="" header="" cancel={() => setJustShow(false)}>
        <Container>
          <div className="just-screen-wrap">
            <div className={`animate-div just-screen-one ${justType === 'two' ? 'active-one' : ''}`}>
              <h4>扩展屏幕连接</h4>
              <div className="just-one-tip">
                请下载Just App，点击右上角“<span></span>”扫码连接扩展屏幕。
              </div>
              <div className="just-one-ewm">
                <img src={QRImgUrl} />
              </div>
            </div>
            <div className={` animate-div just-screen-two ${justType === 'two' ? 'active-two' : ''}`}>
              <div className="just-two-success">
                <span></span>
                <p className="just-success-tip">扩展屏幕已连接</p>
              </div>
              <h4>请选择展示画面</h4>
              <div className="just-stream-list">
                <div className="just-stream-item">
                  <div className="just-video" onClick={() => chooseStream('local')}>
                    <img src={just_l} />
                  </div>
                  <div className={`just-choose-btn ${justChoose === 'local' ? 'active' : ''}`} onClick={() => chooseStream('local')}></div>
                </div>
                <div className="just-stream-item">
                  <div className="just-video" onClick={() => chooseStream('just')}>
                    <img src={just_j} />
                  </div>
                  <div className={`just-choose-btn ${justChoose === 'just' ? 'active' : ''}`} onClick={() => chooseStream('just')}></div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Modal>
    </>
  )
}

const Container = styled(motion.div)`
  .just-screen-wrap {
    -webkit-perspective: 800px;
    -moz-perspective: 800px;
    perspective: 800px;
    width: 100%;
    height: 45vh;
  }
  .just-screen-one {
    -webkit-transform: rotateY(0);
    -moz-transform: rotateY(0);
    transform: rotateY(0);
    &.active-one {
      -webkit-transform: rotateY(180deg);
      -moz-transform: rotateY(180deg);
      transform: rotateY(180deg);
    }
    & > h4 {
      font-size: 2vh;
      font-weight: 500;
      text-align: center;
    }
    .just-one-tip {
      font-size: 1.6vh;
      font-weight: 400;
      margin: 4vh 0 5vh;
      text-align: center;
      & > span {
        display: inline-block;
        vertical-align: middle;
        margin: 0 3px;
        width: 4vh;
        height: 4vh;
        background: url('${just_sao}') no-repeat;
        background-size: contain;
      }
    }
    .just-one-ewm {
      text-align: center;
      img {
        border: 1px solid #eeeeee;
        border-radius: 1.9vh;
        width: 22.8vh;
        height: 22.8vh;
        margin: 0 auto;
      }
    }
  }

  .just-screen-two {
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    transform: rotateY(180deg);
    &.active-two {
      -webkit-transform: rotateY(0);
      -moz-transform: rotateY(0);
      transform: rotateY(0);
    }
    .small-ewm {
      cursor: pointer;
      position: absolute;
      left: 2vh;
      top: 2vh;
      display: block;
      width: 20px;
      height: 20px;
      background: url('${just_small_ewm}') no-repeat;
      background-size: contain;
    }
    .just-two-success {
      padding-bottom: 2.5vh;
      border-bottom: 1px #eee solid;
      span {
        display: block;
        width: 4.8vh;
        height: 4.8vh;
        margin: 0 auto;
        background: url('${just_success}') no-repeat;
        background-size: contain;
      }
      .just-success-tip {
        font-size: 1.6vh;
        font-weight: 400;
        margin-top: 1.2vh;
        text-align: center;
      }
    }
    & > h4 {
      font-size: 2vh;
      font-weight: 500;
      margin: 2.5vh auto 2vh;
      text-align: center;
    }
    .just-stream-list {
      display: flex;
      justify-content: space-evenly;
      .just-stream-item {
        width: 16.7vh;
        .just-video {
          cursor: pointer;
          width: 100%;
          height: 22.3vh;
          border-radius: 1.4vh;
          overflow: hidden;
          /* border-radius: 1.4vh;
        background: #333; */
          img {
            width: 100%;
            height: 100%;
          }
          /* 视频矫正样式 */
          &.mirror {
            transform: rotateY(180deg) rotateZ(0);
          }
          &.flip {
            transform: rotateY(0) rotateZ(180deg);
          }
          &.flip_mirror {
            transform: rotateY(180deg) rotateZ(180deg);
          }
        }
        .just-choose-btn {
          cursor: pointer;
          width: 20px;
          height: 20px;
          background: url('${just_choose_no}') no-repeat;
          background-size: contain;
          margin: 1.2vh auto 0;
          &.active {
            background-image: url('${just_choose}');
          }
        }
      }
    }
  }
  .animate-div {
    background: #fff;
    border-radius: 1.4vh;
    width: 100%;
    height: 45vh;
    position: absolute;
    box-sizing: border-box;
    color: #333;
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;
    transform-style: preserve-3d;
    -webkit-transition: 0.8s ease-in-out;
    -moz-transition: 0.8s ease-in-out;
    transition: 0.8s ease-in-out;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
    &.animate-nocover {
      transition: none;
    }
  }
  .header-tab {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 3.1372vh;
    height: 2.4074vh;
    list-style: none;
    position: relative;
    & .item {
      font-size: 1.6666vh;
      font-weight: 500;
      color: #999999;
      cursor: pointer;
      margin-left: 2.2222vh;
      &:first-of-type {
        margin-left: 0;
      }
      &.cur {
        color: #333333;
      }
    }
  }
  .tab-bar {
    overflow: hidden;
    p {
      transition: transform 0.2s;
      width: 2.2222vh;
      height: 4px;
      background-color: #ff5050;
      margin: 0;
      margin-left: 0.55vh;
      border-radius: 6px;
    }
  }
  .device-list {
    list-style: none;
    padding-top: 2.2222vh;
    height: 33.7vh;
  }

  .network-info-box {
    margin-top: 2.2222vh;
    height: 33.7vh;
  }
  .network-info {
    list-style: none;
    padding-left: 2.2222vh;
    padding-right: 2.2222vh;
    padding-bottom: 2.2222vh;
    border-radius: 1.4814vh;
    border: 0.0925vh solid #e8e8e8;
  }
  .tabel-line {
    height: 4.444vh;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 2.2222vh;
    &:first-of-type {
      & span {
        font-size: 1.4814vh;
        font-weight: 500;
        color: #333333;
        line-height: 1.4814vh;
      }
    }
    &:nth-of-type(even) {
      background-color: #f7f7f7;
    }
    & span {
      font-size: 1.4814vh;
      font-weight: 400;
      color: #999999;
      &:first-of-type {
        width: 10.3703vh;
        color: #333333;
      }
      &:nth-of-type(2) {
        width: 16.574vh;
      }
      &:nth-of-type(3) {
        flex: 1;
      }
    }
  }
  .log-tips {
    margin: 0;
    margin-top: 2.8vh;
    text-align: center;
    font-size: 1.2962vh;
    font-weight: 400;
    color: #999999;
  }
`
